import type { AxiosResponse } from 'axios';
import type { UseMutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';

type Vars = {
  highlightIdentifier?: string;
  momentId: number;
  transcriptId: number;
};
type Options = UseMutationOptions<unknown, AxiosResponse, Vars>;

export const useDeleteTranscriptMomentMutation = (options?: Options) => {

  const apiClient = useChatApiClient();

  return useMutation({
    mutationFn: (data: Vars) => {
      return apiClient.transcripts.deleteTaggedMoment({
        momentId: data.momentId,
        transcriptId: data.transcriptId,
      });
    },
    ...options,
  });
};